import { render, staticRenderFns } from "./FeatureEditStatusField.vue?vue&type=template&id=0a32f164"
import script from "./FeatureEditStatusField.vue?vue&type=script&lang=js"
export * from "./FeatureEditStatusField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports